<div class="footer" [ngStyle]="{'padding-bottom': bookingSteps.length > 0 ? '150px' : '0px'}">
    <div class="footer-holder">
        <div>
            <app-footer-fallback *ngIf="showFallback"></app-footer-fallback>
            <!-- <div class="site-footer" *ngIf="!showFallback && footerHasData"> -->
            <div class="site-footer" >
                <div class="mod-hidden" id="anchor-contacts">{{'footer.text.footerContacts' | ibeadmin | async }}</div>
                <div class="container">
                    <div id="footer-social-section">
                        <div class="info-section">
                            <div class="foot-sections">
                                <div class="foot-section" *ngFor="let section of this.SECTIONS" [attr.aria-expanded]="section.state == 'expanded' ? true : false">
                                    <div (click)="INDRA_handleToggle(section)" class="expand-container">
										<span class="foot-section-title">{{ section.label | ibeadmin | async }}</span>
										<app-svg class="expand-icon" [ngClass]="['toggle-expand', section.state]"
											svg="icons.svg#general--arrow--bottom"
											[attr.aria-label]="'Expand and collapse action'"
											[alt]="'Arrow icon'"></app-svg>
									</div>
                                    <app-expand-collapse [state]="section.state">
                                        <ul class="footer-information">
                                            <li *ngFor="let bullet of section.items">
                                                <a [href]="bullet[1]" title="" target="_blank">{{bullet[0] | ibeadmin | async }}</a>												
                                            </li>
                                        </ul>
                                    </app-expand-collapse>
                                    <ul class="footer-information isDesktop">
                                        <li *ngFor="let bullet of section.items">
                                            <a [href]="bullet[1]" title="" target="_blank">{{bullet[0] | ibeadmin | async }}</a>												
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="foot-social">
                            <div class="tap-logo">
                                <a (click)="INDRA_handleItemClick()" tabindex="0" aria-label='Go to home page'
                                    role="button" href="javascript:;">
                                    <app-svg svg="{{INDRA_getLogo()}}" [alt]="'TAP Air Portugal logo'"></app-svg>
                                </a>
                            </div>
                            <div class="social-container">
                                <div class="foot-title">
                                    <span>{{'footer.text.FollowUsSectionTitle' | ibeadmin | async }}</span>
                                </div>
                                <div class="footer-information js-not-accordion">
                                    <ul class="social-icons-set">
                                        <li *ngFor="let socialNetwork of footer.ListSocialNetworks; let i = index">
                                            <a (click)="INDRA_openUrl(socialNetwork.Url)" [target]="socialNetwork.Target" [title]="socialNetwork.Text" [ngClass]="i === 0 ? 'icn first' : 'icn'">
                                                <img [src]="socialNetwork.Icon" class="img" alt="" />
                                                <span class="mod-hidden">{{'text.opensNewWindow' | ibeadmin | async}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                            <div class="app-container">
                                <div class="foot-title">
                                    {{'footer.text.FollowUsStoreSection' | ibeadmin | async }}
                                </div>
                                <div class="area-app-wrapper">
                                    <a *ngFor="let appStoreButton of footer.ListAppStoreButton" [href]="appStoreButton.Url" [target]="appStoreButton.Target" [attr.aria-label]="appStoreButton.Text" >
                                      <app-svg [svg]="appStoreButton.Icon"
											[alt]="appStoreButton.Text"></app-svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div id="foot-star-section">
                        <div class="elements">
                            <div class="footer-change-view mod-vanished">
                                <div class="view-mobile">{{'footer.text.mobileVersion' | ibeadmin | async }}</div>
                                <div class="view-desktop">{{'footer.text.desktopVersion' | ibeadmin | async }}</div>
                            </div>
                            <span class="copyright">
                                © {{'footer.text.year' | ibeadmin | async }}, TAP.  {{'footer.text.allRightsReserved' | ibeadmin | async }}
                            </span>
                        </div>
                        <div class="elements">
                            <a href="http://www.staralliance.com/pt/home" target="_blank" [title]="'footer.title.linkOpensANewWindow' | ibeadmin | async">
                                <img src="assets/header-footer/images/starAlliance_black.svg" class="credits" alt="Star Alliance" />
                                <span class="mod-hidden">{{'footer.text.opensNewWindow' | ibeadmin | async }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
             <!-- DO NOT REMOVE: Used for version tracking and deployments -->
            <div style="display: none; visibility: hidden;">v0.5.64</div>
        </div>
    </div>
</div>
